export default __webpack_public_path__ + "static/media/Video_1.a2f68ff4.mp4";